import { render, staticRenderFns } from "./area-position.vue?vue&type=template&id=dee696f0&scoped=true"
import script from "./area-position.vue?vue&type=script&lang=js"
export * from "./area-position.vue?vue&type=script&lang=js"
import style0 from "./area-position.vue?vue&type=style&index=0&id=dee696f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee696f0",
  null
  
)

export default component.exports